import { useEffect } from 'react';
import { trackSectionView } from '@/lib/tracking';

/**
 * Registra la primera vez que una sección con `id` entra en viewport.
 * Sirve para saber hasta dónde llegó el usuario en la landing.
 */
export function useSectionViews(): void {
  useEffect(() => {
    const seen = new Set<string>();
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target as HTMLElement;
          const id = el.id?.trim();
          if (!id || seen.has(id)) continue;
          seen.add(id);
          trackSectionView(id);
        }
      },
      { threshold: 0.35, rootMargin: '0px 0px -10% 0px' }
    );

    const observe = () => {
      document.querySelectorAll<HTMLElement>('section[id], .hero[id]').forEach((node) => {
        observer.observe(node);
      });
    };

    observe();
    // Secciones pueden montarse un tick después (mobile/desktop swap).
    const t = window.setTimeout(observe, 400);
    return () => {
      window.clearTimeout(t);
      observer.disconnect();
    };
  }, []);
}
